import { render, staticRenderFns } from "./ThereIsNoDrugStores.vue?vue&type=template&id=532948b8"
import script from "./ThereIsNoDrugStores.vue?vue&type=script&lang=js"
export * from "./ThereIsNoDrugStores.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports